/* Website2 native Ajax cart candidate. Draft 188549005601 only.
 * Release evidence remains CLOSED; msg10495 separately authorizes draft operations.
 * Runtime product, allocation, readback and genuine gift checks remain mandatory.
 * No cart token, customer address, or session cart is persisted or logged.
 */
(function (root, factory) {
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.FECNativeCart = api;
})(typeof window === 'object' ? window : globalThis, function () {
  'use strict';
  const TARGET_THEME = 188549005601;
  const PACKS = Object.freeze({
    1: Object.freeze({ id: 51413498593569, price: 2500, recurring: 2200, plans: Object.freeze({30: 691447464225, 60: 691447496993}) }),
    2: Object.freeze({ id: 51428252188961, price: 4800, recurring: 3600, plans: Object.freeze({30: 691447529761, 60: 691447562529}) }),
    3: Object.freeze({ id: 51428252221729, price: 6900, recurring: 4900, plans: Object.freeze({30: 691447595297, 60: 691447628065}) })
  });
  const COVER = 50560708772129, SD = 53188166877473, GIFT = 50560708804897;
  const PAIR_PROPERTY = '_fec_sd_offer', PAIR_VALUE = 'website2-native-bxgy-v1';
  const paired = line => line.properties?.[PAIR_PROPERTY] === PAIR_VALUE && [SD,GIFT].includes(Number(line.variant_id));
  const PRODUCTS = Object.freeze([{id:10028819808545, handle:'high-lady-hl24lp1'}, {id:9768081588513, handle:'hard-cover'}]);
  // Saved backend identity ONLY. This is not runtime/release acceptance.
  // Keep mixed compatibility unaccepted and every production release gate closed.
  const STAGED_GIFT_MAPPING = Object.freeze({"mechanism":"shopify_automatic_bxgy","evidenceId":"saved-native-bxgy-1692177269025-sha256:22c14598446fc3452b37feb514ded1ab4410d1043833782d907dad412d4654d4","discountId":"1692177269025","discountTitle":"Shadow Daddy preorder — complimentary matching cover","buyVariantId":53188166877473,"getVariantId":50560708804897,"buyQuantity":1,"getQuantity":1,"maxPerOrder":1,"oneTimeOnly":true,"mixedSubscriptionCompatible":false,"mixedSubscriptionProofStatus":"not_accepted_for_release","savedCombinesWith":["product","order","shipping"],"releaseAccepted":false,"sourceProofSha256":"22c14598446fc3452b37feb514ded1ab4410d1043833782d907dad412d4654d4","verifiedSubscriptionPlanIds":[691447464225],"subscriptionCompatibilityScope":"Backend native checkout proved new HL1 30-day plan only; not universal","adapterContractSha256":"00802aabae65cc7343470cf73f7bf4f3044745778f6bd3a2dc0e506c850cf9ad"});
  const CLOSED = Object.freeze({mutations:false, checkout:false, allocations:false, gift:false, shipping:false, evidenceId:null, giftMapping:STAGED_GIFT_MAPPING, policyPlanIds:Object.freeze([])});
  const clone = o => JSON.parse(JSON.stringify(o));
  const assert = (ok, message) => { if (!ok) throw new Error(message); };
  const planId = l => Number(l.selling_plan_allocation?.selling_plan?.id || 0);
  const packSize = l => Number(Object.keys(PACKS).find(n => PACKS[n].id === Number(l.variant_id)) || 0);
  const kind = l => Number(l.variant_id) === SD ? 'sd' : Number(l.variant_id) === GIFT ? 'sd-cover' : Number(l.variant_id) === COVER ? 'cover' : packSize(l) ? 'hl' : 'other';
  function cartShape(cart) {
    assert(cart && Array.isArray(cart.items) && Number.isInteger(cart.total_price) && cart.total_price >= 0 && typeof cart.currency === 'string', 'Shopify returned an unreadable cart. Refresh before continuing.');
    const keys = new Set();
    for (const l of cart.items) {
      assert(typeof l.key === 'string' && l.key && !keys.has(l.key) && Number.isInteger(l.quantity) && l.quantity > 0 && Number.isInteger(l.final_line_price) && l.final_line_price >= 0 && Number.isInteger(l.final_price) && Number.isSafeInteger(Number(l.variant_id)), 'Shopify returned an unreadable cart line.');
      keys.add(l.key);
    }
    return cart;
  }
  // Uses the returned plan name/options, never relabels a legacy month plan as days.
  function cadence(line) {
    const a = line.selling_plan_allocation;
    if (!a) return 'One-time purchase';
    return a.selling_plan.name || a.selling_plan.options?.map(o => o.value).join(' · ') || 'Subscription — review terms at checkout';
  }
  function create(options = {}) {
    const fetcher = options.fetch || globalThis.fetch.bind(globalThis);
    const gates = Object.freeze({...CLOSED, ...(options.gates || {})});
    const route = options.root || '/';
    assert(/^\/(?!\/)[a-zA-Z0-9/_-]*\/$/.test(route) || route === '/', 'Invalid Shopify locale root.');
    const theme = options.theme || (typeof window === 'object' ? window.Shopify?.theme : null);
    // User msg10495 authorizes operations on this exact unpublished theme only.
    // This is not release acceptance; CLOSED, evidenceId and shipping stay unchanged.
    const authorizedDraft = theme?.id === TARGET_THEME && (theme.role === 'unpublished' || theme.role === 'main');
    const operations = Object.freeze({mutations:authorizedDraft, checkout:authorizedDraft, gift:authorizedDraft, authorization:'msg10495'});
    let cart = null, products = [], busy = false, error = '', uncertain = false, shippingQuotes = null, retryNotBefore = 0;
    const now = options.now || Date.now;
    const listeners = new Set();
    // Native automatic BXGY enforces price/eligibility. The private property ONLY
    // associates the two lines for UI removal; it grants no discount or free price.
    // Exact discount ID/title/qualifiers and compatibility proof come from ops.
    const giftMapping = gates.giftMapping;
    const snapshot = () => ({cart:cart ? clone(cart) : null, products:clone(products), busy, error, uncertain, shippingQuotes:shippingQuotes ? clone(shippingQuotes) : null, gates:{...gates}, operations:{...operations}});
    const emit = () => listeners.forEach(fn => fn(snapshot()));
    const checkTheme = () => assert(theme?.id === TARGET_THEME && (theme.role === 'unpublished' || theme.role === 'main'), 'Cart integration is restricted to the unpublished Website2 theme.');
    async function request(path, body) {
      assert(now() >= retryNotBefore, 'Shopify is rate-limiting requests. Please wait before refreshing or retrying.');
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 20000);
      try {
        const response = await fetcher(route + path, {method:body ? 'POST' : 'GET', credentials:'same-origin', cache:'no-store', headers:{Accept:'application/json', ...(body ? {'Content-Type':'application/json'} : {})}, ...(body ? {body:JSON.stringify(body)} : {}), signal:controller.signal});
        if (response.status === 429) {
          const header = response.headers?.get('Retry-After'), seconds = Number(header);
          retryNotBefore = now() + (header && Number.isFinite(seconds) ? Math.max(1,seconds)*1000 : Math.max(60000,(Date.parse(header)||0)-now()));
        }
        const data = await response.json();
        assert(response.ok, typeof data.description === 'string' ? data.description : `Shopify request failed (${response.status}).`);
        return data;
      } finally { clearTimeout(timer); }
    }
    async function readCart() { shippingQuotes = null; cart = cartShape(await request('cart.js')); return cart; }
    async function readProducts() {
      const next = await Promise.all(PRODUCTS.map(async expected => {
        const p = await request('products/' + expected.handle + '.js');
        assert(p.id === expected.id && p.handle === expected.handle && Array.isArray(p.variants), 'Product identity changed; purchasing is paused.');
        return p;
      }));
      products = next;
    }
    const variant = id => products.flatMap(p => p.variants).find(v => Number(v.id) === Number(id));
    function oneTime(id, expected) {
      const v = variant(id);
      assert(v && v.available && v.price === expected && !v.requires_selling_plan, 'This exact one-time product is unavailable or its price changed. Nothing has been substituted.');
      return {id, quantity:1};
    }
    function pack(selection) {
      const n = selection.quantity, p = PACKS[n];
      assert(p && ['subscribe','one-time'].includes(selection.mode), 'This pack has no verified native variant. Four-box ordering remains unavailable.');
      if (selection.mode === 'one-time') return oneTime(p.id, p.price);
      assert([30,60].includes(selection.days), 'Only 30-day or 60-day plans are supported.');
      const id = p.plans[selection.days], v = variant(p.id);
      assert(v?.available && v.price === p.price, 'This exact refill pack is unavailable or its base price changed.');
      const a = v.selling_plan_allocations?.find(a => Number(a.selling_plan_id) === id);
      const group = products[0]?.selling_plan_groups?.find(g => g.selling_plans?.some(s => Number(s.id) === id));
      const plan = group?.selling_plans.find(s => Number(s.id) === id);
      assert(a && plan?.recurring_deliveries && a.price === p.recurring && a.per_delivery_price === p.recurring, 'The requested Appstle allocation or recurring price is not available. Legacy plans are never substituted.');
      assert(String(a.selling_plan_group_id) === String(group.id), 'Selling-plan allocation group mismatch.');
      return {id:p.id, quantity:1, selling_plan:id};
    }
    function quote(selection) {
      try { const item = pack(selection), v = variant(item.id); return {available:true, cents:item.selling_plan ? v.selling_plan_allocations.find(a => Number(a.selling_plan_id) === item.selling_plan).price : v.price}; }
      catch(e) { return {available:false, reason:e.message}; }
    }
    const has = id => !!cart?.items.some(l => Number(l.variant_id) === id && !planId(l));
    function mappingReady() {
      return !!(operations.gift && giftMapping?.evidenceId &&
        giftMapping.mechanism === 'shopify_automatic_bxgy' && typeof giftMapping.discountId === 'string' && giftMapping.discountId &&
        typeof giftMapping.discountTitle === 'string' && giftMapping.discountTitle && giftMapping.buyVariantId === SD &&
        giftMapping.getVariantId === GIFT && giftMapping.buyQuantity === 1 && giftMapping.getQuantity === 1 &&
        giftMapping.maxPerOrder === 1 && giftMapping.oneTimeOnly === true);
    }
    function giftStatus() {
      const buys = cart?.items.filter(l => paired(l) && Number(l.variant_id) === SD) || [];
      const gifts = cart?.items.filter(l => paired(l) && Number(l.variant_id) === GIFT) || [];
      const gift = gifts[0], buy = buys[0];
      // Shopify Ajax may return an empty type for this native BXGY allocation.
      // Accept that observed shape only with its exact allocation metadata and actual free price below.
      const matched = gift?.line_level_discount_allocations?.filter(a => {
        const d = a.discount_application;
        return d?.title === giftMapping?.discountTitle && (d.type === 'automatic' ||
          (d.type === '' && d.value_type === 'percentage' && Number(d.value) === 100 &&
           d.allocation_method === 'each' && d.target_selection === 'entitled' &&
           d.target_type === 'line_item' && d.total_allocated_amount === 1200));
      }) || [];
      const noWrongTarget = !cart?.items.some(l => Number(l.variant_id) !== GIFT && l.line_level_discount_allocations?.some(a => a.amount > 0 && a.discount_application?.title === giftMapping?.discountTitle));
      const freeQuantity = cart?.items.filter(l=>Number(l.variant_id)===GIFT&&l.final_line_price===0).reduce((n,l)=>n+l.quantity,0) || 0;
      const valid = !!(mappingReady() && buys.length === 1 && gifts.length === 1 && buy.quantity === 1 && gift.quantity === 1 &&
        !planId(buy) && !planId(gift) && buy.final_line_price > 0 && gift.final_price === 0 && gift.final_line_price === 0 &&
        gift.original_line_price === 1200 && matched.reduce((n,a)=>n+a.amount,0) === 1200 && noWrongTarget && freeQuantity === 1);
      const relevant=cart?.items.filter(l=>[SD,GIFT].includes(Number(l.variant_id)))||[];
      const repairable=relevant.length===1&&paired(relevant[0])&&!planId(relevant[0])&&relevant[0].quantity===1;
      return {valid, confirmedGiftKey:valid ? gift.key : null, pairPresent:buys.length>0||gifts.length>0, repairable, missingVariantId:repairable?(buys.length?GIFT:SD):null};
    }
    function giftReady() {
      assert(mappingReady(), 'The matching cover offer is unavailable. Remove this selection or refresh and try again.');
      oneTime(SD,2500); oneTime(GIFT,1200);
    }
    function checkoutReasons() {
      const reasons = [];
      if (!operations.checkout) reasons.push('Purchasing is unavailable for this theme.');
      if (!cart?.items.length) reasons.push('Your cart is empty.');
      if (busy || uncertain || error) reasons.push('Refresh and review the actual cart before continuing.');
      if (cart?.currency !== 'USD') reasons.push('This currency has not been verified for the Website2 offer.');
      for (const l of cart?.items || []) {
        const size = packSize(l), expected = size ? PACKS[size].price : Number(l.variant_id) === SD ? 2500 : [COVER,GIFT].includes(Number(l.variant_id)) ? 1200 : null;
        if (expected !== null) {
          try {
            if (size && planId(l)) {
              const days = Number(Object.keys(PACKS[size].plans).find(d => PACKS[size].plans[d] === planId(l)));
              pack({quantity:size,mode:'subscribe',days});
            } else oneTime(Number(l.variant_id),expected);
          } catch(e) { reasons.push(e.message); }
        }
        if (['cover','sd','sd-cover'].includes(kind(l)) && planId(l)) reasons.push('An add-on has an unexpected subscription plan.');
        if (packSize(l) && planId(l)) {
          const p = PACKS[packSize(l)];
          if (!Object.values(p.plans).includes(planId(l)) || l.selling_plan_allocation.price !== p.recurring || l.selling_plan_allocation.per_delivery_price !== p.recurring) reasons.push('A refill line has unverified subscription terms. Existing items have been preserved.');
        }
      }
      const offer = giftStatus();
      if ((offer.pairPresent || has(SD)) && !offer.valid) reasons.push('Shopify has not confirmed the exact native Buy X Get Y allocation and zero-priced matching cover.');
      if (!has(SD) && cart?.items.some(l=>Number(l.variant_id)===GIFT&&l.final_line_price===0)) reasons.push('A cover alone must remain paid; a standalone free cover is not a verified offer.');
      return [...new Set(reasons)];
    }
    async function exclusive(work, mutation = false) {
      assert(!busy, 'A cart update is already in progress.');
      busy = true; error = ''; emit();
      const execute = async () => {
        let mutationAuthorized = false;
        try {
          checkTheme();
          if (mutation) assert(operations.mutations, 'Purchasing is unavailable for this theme.');
          mutationAuthorized = mutation;
          const result = await work(); uncertain = false; return result;
        } catch(e) {
          error = e.name === 'AbortError' ? 'The request timed out. Review the refreshed cart before retrying.' : e.message;
          if (mutationAuthorized) {
            uncertain = true;
            try { await readCart(); uncertain = false; } catch(_) { cart = null; }
            error += ' Review the actual cart before retrying; a failed add can still change inventory-limited quantities.';
          }
          throw new Error(error);
        } finally { busy = false; emit(); }
      };
      // Serialize participating Website2 tabs; Shopify cannot atomically lock external apps.
      const locks = options.locks || globalThis.navigator?.locks;
      if (locks) return locks.request('fec-native-cart', execute);
      return execute();
    }
    async function refresh() { return exclusive(async () => { await Promise.all([readCart(),readProducts()]); return snapshot(); }); }
    async function add(selection) {
      return exclusive(async () => {
        await Promise.all([readCart(),readProducts()]);
        assert(cart.currency === 'USD', 'This currency is not verified.');
        const items = selection.quantity ? [pack(selection)] : [];
        if (selection.cover && !has(COVER)) items.push(oneTime(COVER,1200));
        const withSD = !!selection.sd;
        if (withSD && !giftStatus().valid) {
          giftReady();
          const sdLines=cart.items.filter(l=>Number(l.variant_id)===SD), giftLines=cart.items.filter(l=>Number(l.variant_id)===GIFT);
          // Recover only an unambiguous offer we already track. Never adopt an
          // unrelated paid cover or duplicate an existing SD/gift line silently.
          assert(sdLines.length<=1 && giftLines.length<=1 && [...sdLines,...giftLines].every(l=>paired(l)&&!planId(l)&&l.quantity===1), 'Existing unpaired or ambiguous Shadow Daddy lines need review. Existing paid items are preserved; no duplicate cover was added.');
          assert(!sdLines.length || !giftLines.length, 'Shopify has not confirmed the existing pair discount. Refresh/review the actual prices; no duplicate lines were added.');
          if(!sdLines.length)items.push({...oneTime(SD,2500),properties:{[PAIR_PROPERTY]:PAIR_VALUE}});
          if(!giftLines.length)items.push({...oneTime(GIFT,1200),properties:{[PAIR_PROPERTY]:PAIR_VALUE}});
        }
        const expectedCounts = items.map(item => ({...item, count:cart.items.filter(l => Number(l.variant_id) === item.id && planId(l) === (item.selling_plan || 0)).reduce((n,l) => n+l.quantity,0)+item.quantity}));
        if (items.length) await request('cart/add.js',{items});
        await readCart();
        for (const item of expectedCounts) assert(cart.items.filter(l => Number(l.variant_id) === item.id && planId(l) === (item.selling_plan || 0)).reduce((n,l) => n+l.quantity,0) === item.count, 'Shopify did not confirm the requested quantity. Review the actual cart; do not assume the whole offer was added.');
        if (withSD) assert(giftStatus().valid, 'Shopify did not apply the verified Buy X Get Y discount to the matching cover. Its actual charge is shown; checkout remains blocked.');
        return snapshot();
      },true);
    }
    async function change(key, quantity) {
      assert(typeof key === 'string' && key.includes(':') && Number.isInteger(quantity) && quantity >= 0 && quantity <= 99, 'Invalid cart line key or quantity.');
      return exclusive(async () => {
        await readCart();
        const line = cart.items.find(l => l.key === key);
        assert(line, 'This line changed in another tab or app. Review the refreshed cart and try again.');
        if (paired(line)) {
          assert(mappingReady(), 'Native offer mapping is not verified. No related lines were changed.');
          assert(quantity === 0 || quantity === 1, 'This preorder offer is limited to one pair per order.');
          if (quantity === 0) {
            assert(!cart.items.some(l=>Number(l.variant_id)===SD&&!planId(l)&&!paired(l)), 'Other qualifying SD lines need explicit review before removing this tracked offer. No related lines were changed.');
            // Gift first: never intentionally leave a paid orphan gift after removing SD.
            // Discount changes can change OTHER line keys: refresh before the next key.
            assert([GIFT,SD].every(id=>cart.items.filter(l=>paired(l)&&Number(l.variant_id)===id).length<=1), 'Multiple related lines need review; no cart lines were changed.');
            for (const id of [GIFT,SD]) {
              const related = cart.items.filter(l=>paired(l)&&Number(l.variant_id)===id);
              assert(related.length <= 1, 'Multiple related lines need review; no broad cart changes were made.');
              if (related.length) { await request('cart/change.js',{id:related[0].key,quantity:0}); await readCart(); }
            }
          }
        } else {
          assert(kind(line) !== 'cover' || quantity <= 1, 'This offer includes at most one paid hardcover.');
          await request('cart/change.js',{id:key, quantity});
        }
        await readCart(); return snapshot();
      },true);
    }
    async function quoteShipping(address) {
      return exclusive(async () => {
        assert(gates.shipping && gates.evidenceId, 'Backend shipping enforcement is awaiting verification.');
        assert(address && typeof address.zip === 'string' && /^\d{5}(-\d{4})?$/.test(address.zip.trim()) && typeof address.province === 'string' && /^[A-Za-z .-]{2,40}$/.test(address.province.trim()), 'Enter a US state and ZIP code to request a Shopify estimate.');
        await readCart();
        assert(cart.items.length && cart.currency === 'USD', 'Add eligible USD merchandise before requesting shipping.');
        const query = new URLSearchParams({'shipping_address[country]':'United States','shipping_address[province]':address.province.trim(),'shipping_address[zip]':address.zip.trim()});
        // Documented GET endpoint: one user-triggered request, no auto-poll/retry.
        // Destination is not persisted in client state, local storage, or logs.
        const data = await request('cart/shipping_rates.json?' + query.toString());
        assert(Array.isArray(data.shipping_rates), 'Shopify did not return shipping estimates.');
        shippingQuotes = data.shipping_rates.map(rate => {
          assert(typeof rate.name === 'string' && /^\d+(\.\d{1,2})?$/.test(String(rate.price)), 'Shopify returned an unreadable shipping estimate.');
          return {name:rate.presentment_name || rate.name, cents:Math.round(Number(rate.price)*100)};
        });
        return snapshot();
      });
    }
    async function checkout() {
      await refresh();
      const reasons = checkoutReasons(); assert(!reasons.length, reasons.join(' '));
      checkTheme();
      // Only a successfully read real cart may proceed. No checkout/order/payment API.
      const redirect = options.redirect || (url => window.location.assign(url));
      redirect(route + 'checkout');
    }
    return {subscribe(fn){listeners.add(fn);fn(snapshot());return () => listeners.delete(fn);}, snapshot, refresh, add, change, checkout, checkoutReasons, quote, quoteShipping, giftStatus};
  }
  return Object.freeze({create, PACKS, COVER, SD, GIFT, PRODUCTS, CLOSED, packSize, kind, cadence, cartShape, paired, PAIR_PROPERTY, PAIR_VALUE});
});
